module.exports = "build/assets/mediaLiteracy.17ce6579.png";